import React from 'react';
import { subsetByURI } from '../../virtuoso/helper'

/**
 *  Набор специальных классов, которые отображают или редактируют свойства элементов каталога 
 *  Для литеральных свойств имеется дополнительная возможность перевода значения на другой язык.
 * 
 *  Получение компонент из factory
 *   factory.ui.getUIComponent(predicat)  - получение компоненты для просмотра 
 *   factory.ui.getUIComponent(predicat, "edit") - получение компоненты для редактирования
 */


/** Для отображения значения поля. Для отображения необходимо указать:
 * 1. Предикат, содержащий данные
 * 2. Массив данных из которых их брать
 * 3. Язык
 * 4. Фабрика, которая возвращает компоненту для создания
 */
 export const FieldViewProxy = ({predicat, values, lang, factory, action, history, ...props}) =>{
  const Component = factory.ui.getUIComponent(predicat);
  return (
    <div className="csi_value_div" style={{"overflowWrap": "anywhere"}} property={predicat}>
      <Component lang={lang} uri={predicat} values={values} factory={factory} action={action} history={history} {...props}/>
    </div>
  )
}

/** 
* Для отображение редактирование поля.
* Редактирование обеспечивается созданием формы ввода.
*/
export const FieldEditProxy = ({predicat, values, lang, factory, vselected, subject, selected = undefined, 
  action=f=>f, onReload=undefined, ...props}) =>{
  const Component = factory.ui.getUIComponent(predicat, "edit");
  const data = subsetByURI(values, predicat);
  return (
    <div className="csi_value_div" style={{"overflowWrap": "anywhere"}} >
      <Component lang={lang} subject={subject} predicat={predicat} uri={predicat} values={data} factory={factory}      
        action={action} selected={selected} onReload={onReload} {...props} />
    </div>
  )
};